export abstract class KeyPress {
  protected key!: string
  protected shift = false
  protected ctrl = false
  protected meta = false
  protected alt = false
  protected triggeredKeycode!: number

  start(e: KeyboardEvent) {
    if (e.key === this.key &&
      e.shiftKey === this.shift &&
      e.ctrlKey === this.ctrl &&
      e.metaKey === this.meta &&
      e.altKey === this.alt
    ) {
      this.triggeredKeycode = e.keyCode
      return true
    }
  }

  end(e: KeyboardEvent) {
    if (e.keyCode === this.triggeredKeycode) {
      return true
    }
  }

  private isDown = false
  keydown(e: KeyboardEvent) {
    if (e.target === document.body) {
      if (!this.isDown && this.start(e)) {
        e.preventDefault()
        this.isDown = true
        this.down(e)
      }
    }
  }
  keyup(e: KeyboardEvent) {
    if (this.isDown && this.end(e)) {
      e.preventDefault()
      this.isDown = false
      this.up()
    }
  }
  windowBlur() {
    if (this.isDown) {
      this.isDown = false
      this.up()
    }
  }
  protected abstract down(e: KeyboardEvent): void
  protected abstract up(): void
}
